export default "__VITE_ASSET__CbIx2LU$__"